import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { About, Footer, Header, Skills, Testimonial, Work, ProjectDetails } from './container';
import { Navbar } from './components';
import './App.scss';
import { ThemeProvider } from './context/ThemeContext';

function AppContent() {
  const location = useLocation();
  const isProjectDetails = location.pathname.startsWith('/project/') || location.pathname.startsWith('/work/');

  if (isProjectDetails) {
    return (
      <div className='app'>
        <Navbar />
        <ProjectDetails />
        <Footer />
      </div>
    );
  }

  return (
    <div className='app'>
      <Navbar/>
      <Header/>
      <About/>
      <Work/>
      <Skills/>
      <Testimonial/>
      <Footer/>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<AppContent />} />
          <Route path="/project/:projectId" element={<AppContent />} />
          <Route path="/work" element={<AppContent />} />
          <Route path="/work/:projectId" element={<AppContent />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
